<script lang="ts">
    import { DatePicker } from "@svelte-plugins/datepicker";
    import { uuidv7 } from "uuidv7";
    import { SvelteDate } from "svelte/reactivity";
    import type { SetView } from "../types";

    type Props = {
        setView: SetView;
        flexDirCol?: boolean;
        startDate?: Date;
        id?: string;
        isOpen?: boolean;
        enableFutureDates?: boolean;
        showTimePicker?: boolean;
        viewMode?: 'day' | 'week' | 'month';
        displayLabel?: string;
    };
    let {
        setView,
        flexDirCol = true,
        startDate = $bindable(new SvelteDate()),
        id = uuidv7(),
        isOpen = false,
        enableFutureDates = true,
        showTimePicker = false,
        viewMode,
        displayLabel,
    }: Props = $props();

    const toggleDatePicker = () => (isOpen = !isOpen);

    let dateGetter = $state({
        get internal() {
            return +startDate;
        },
        set internal(val) {
            const newDate = new SvelteDate(val);
            // TODO: this is a really bad solution, it is still reupdating this value every time the display date is updating
            if (newDate.toDateString() !== startDate.toDateString()) {
                startDate = newDate;
                startDate.setHours(9);
            }
        },
    });
</script>

<div class="field" class:flex-dir-col={flexDirCol}>
    <DatePicker
        bind:isOpen
        bind:startDate={dateGetter.internal}
        {showTimePicker}
        {enableFutureDates}
        align="right"
        onDayClick={() => {
            let d = new SvelteDate(startDate);
            if (viewMode === 'week') {
                const day = d.getDay();
                const diff = (day === 0 ? -6 : 1 - day);
                d.setDate(d.getDate() + diff);
                d.setHours(0, 0, 0, 0);
            } else if (viewMode === 'month') {
                d.setDate(1);
                d.setHours(0, 0, 0, 0);
            }
            setView({ displayDate: d });
        }}
    >
        <input
            type="text"
            class="std-input"
            value={displayLabel ?? startDate.toDateString()}
            onclick={toggleDatePicker}
            {id}
            style:--width={`calc(${(displayLabel ?? startDate.toDateString()).length}ch + 1.5rem)`}
        />
    </DatePicker>
</div>

<style lang="scss">
    :global(body) {
        --datepicker-presets-button-background-active: hsl(
            var(--clr-primary-5)
        );
        --datepicker-presets-button-color-active: hsl(var(--clr-on-primary-1));
        --datepicker-calendar-range-selected-background: hsl(
            var(--clr-primary-5)
        );
        --datepicker-calendar-range-selected-color: hsl(
            var(--clr-on-primary-1)
        );
    }

    .field {
        display: flex;
        gap: 0 0.5rem;
        --box-clr: hsl(var(--clr-on-surface-1));
        &.flex-dir-col {
            flex-direction: column;
        }
        :global(.datepicker .calendars-container.show) {
            top: 105%;
            bottom: auto;
        }
    }
    .field input {
        width: var(--width);
        color: #424242;
        background-color: #f6f6f6;
        cursor: pointer;
        transition:
            color 200ms,
            background 200ms;
        &:hover {
            color: #f6f6f6;
            background: #424242;
        }
    }
</style>
